export default __webpack_public_path__ + "static/media/time.b2f09d6b.svg";